import React, { useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import './ImageScrollbar.css';

const ImageScrollbar = ({ value, max, height, onInputCallback }) => {

  const inputRef = useRef(null);

  const handleScrollChange = useCallback(
    (step) => {
      const intValue = value + step;
      if (intValue >= 0 && intValue <= max) {
        onInputCallback(intValue);
      }
    },
    [value, max, onInputCallback]
  );

  const onKeyDown = useCallback(
    (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const step = event.key === 'ArrowDown' ? 1 : -1;
        handleScrollChange(step);
        event.preventDefault();
      }
    },
    [handleScrollChange]
  );

  const onChange = (event) => {
    const intValue = parseInt(event.target.value, 10);
    onInputCallback(intValue);
  };

  useEffect(() => {
    const inputElement = inputRef.current;
    if (inputElement) {
      inputElement.addEventListener('keydown', onKeyDown);
      return () => {
        inputElement.removeEventListener('keydown', onKeyDown);
      };
    }
  }, [onKeyDown]);

  if (max === 0) {
    return null;
  }

  const style = {
    width: `${height}`,
  };

  return (
    <div className="scroll">
      <div className="scroll-holder">
        <input
          ref={inputRef}
          className="imageSlider"
          style={style}
          type="range"
          min="0"
          max={max}
          step="1"
          value={value}
          onChange={onChange}
          autoFocus
        />
      </div>
    </div>
  );
};

ImageScrollbar.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  height: PropTypes.string.isRequired,
  onInputCallback: PropTypes.func.isRequired,
};

export default ImageScrollbar;